module.exports = __webpack_public_path__ + "img/ad-banner.d86295d0.jpg";